module.exports = __webpack_public_path__ + "img/IMG-20210623-WA0003.6b3a28b3.jpg";